import React from "react";

const SMOKER_1 =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/m9owsd78_IMG_9C48FE46-06CC-4E6D-B533-4D0E11ABCE77.jpeg";
const D2_STACKS =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/39ogkkhl_IMG_3341.jpeg";
const D2_FRAME =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/8mj1x54k_IMG_3336.jpeg";
const D1_BUILD =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/5jwq3392_IMG_3327.jpeg";
const D1_TANK =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/wkpd6p2j_IMG_3329.jpeg";
const FORGE_LINEUP =
  "https://customer-assets.emergentagent.com/job_ember-works/artifacts/yoyapkh5_IMG_3345.jpeg";

const builds = [
  {
    id: "D2",
    name: "Model D2",
    sub: "Twin-Stack Reverse Flow",
    spec: "Reclaimed propane tanks · Twin pipe risers · Welded shop build",
    img: SMOKER_1,
    span: "lg:col-span-12",
    badge: "Signature Build",
  },
  {
    id: "D2.2",
    name: "Twin Stack Mount",
    sub: "Model D2 · Final Assembly",
    spec: "Stack alignment & firebox marry-up",
    img: D2_STACKS,
    span: "lg:col-span-7",
    badge: "Shop Floor",
  },
  {
    id: "D2.1",
    name: "V-Frame Weld-Up",
    sub: "Model D2 · Mid-Build",
    spec: "Twin chamber over reclaimed firebox · Pre-stack",
    img: D2_FRAME,
    span: "lg:col-span-5",
    badge: "Shop Floor",
  },
  {
    id: "D1",
    name: "Model D2",
    sub: "Compact Single-Chamber",
    spec: "Reclaimed tank · Splayed-leg base · Hand-cut window",
    img: D1_BUILD,
    span: "lg:col-span-4",
    badge: "Shop Floor",
  },
  {
    id: "D1.1",
    name: "Tank Prep",
    sub: "Model D1 · Frame Fit-Up",
    spec: "Leg layout & burn-marks before grind-down",
    img: D1_TANK,
    span: "lg:col-span-4",
    badge: "Shop Floor",
  },
  {
    id: "FL-01",
    name: "In The Forge",
    sub: "Raw Material Inventory",
    spec: "Reclaimed propane stock awaiting fabrication",
    img: FORGE_LINEUP,
    span: "lg:col-span-4",
    badge: "Cocoa, FL",
  },
];

export default function FeaturedBuilds() {
  return (
    <section
      id="builds"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-zinc-900"
      data-testid="builds-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <span className="font-body text-[10px] tracking-[0.45em] uppercase text-[#FF7A00]">
                /03 — Previous Commissions
              </span>
              <div className="h-px w-12 bg-zinc-800" />
            </div>
            <h2
              className="font-heading uppercase tracking-tight leading-[0.9] text-5xl md:text-6xl lg:text-7xl steel-text"
              data-testid="builds-heading"
            >
              Built Different.
              <br />
              Built By Hand.
            </h2>
          </div>
          <p className="max-w-md text-zinc-400 text-base leading-relaxed">
            A working archive of recent commissions. Each piece is signed,
            numbered, and never duplicated.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6 lg:auto-rows-[480px]">
          {builds.map((b) => (
            <article
              key={b.id}
              data-testid={`build-card-${b.id}`}
              className={`group relative overflow-hidden border border-zinc-900 bg-[#0E0F11] ${b.span} aspect-[4/5] lg:aspect-auto`}
            >
              <img
                src={b.img}
                alt={b.name}
                className="absolute inset-0 h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[1200ms] ease-out"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/5 pointer-events-none" />

              <div className="absolute top-5 left-5 right-5 flex items-start justify-between">
                <span className="font-body text-[10px] tracking-[0.4em] uppercase text-zinc-300">
                  No. {b.id}
                </span>
                <span className="font-body text-[10px] tracking-[0.4em] uppercase text-[#FF7A00]">
                  {b.badge}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="font-heading uppercase tracking-tight text-3xl md:text-4xl text-zinc-100">
                  {b.name}
                </h3>
                <div className="mt-3 h-px w-12 bg-[#D9501E]" />
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-6">
          <p className="text-zinc-500 text-sm font-body uppercase tracking-[0.3em]">
            Full archive available on request.
          </p>
          <a href="#inquiry" className="btn-outline" data-testid="builds-cta-inquiry">
            Start Your Build
          </a>
        </div>
      </div>
    </section>
  );
}
